export default {
  trade: '交易',
  wallet: '钱包',
  history: '历史记录',
}
